// extracted by mini-css-extract-plugin
module.exports = {"title":"policy_data_title__3mtym","desc":"policy_data_desc__2x7hq","price":"policy_data_price__2uM-2","oprice":"policy_data_oprice__3DEh7","btn":"policy_data_btn__3HRrS"};